export default {
  avatar: {
    title: "Cambiar avatar",
  },
  bindRole: {
    allServers: "Todos los Servidores",
    bindFailed: "Error al vincular el personaje",
    bindSuccess: "Personaje vinculado",
    getRoleListFailed: "Error al cargar la lista de personajes",
    getServerListFailed: "Error al cargar la lista de servidores",
    modifyTitle: "Cambiar personaje vinculado",
    noRole: "No hay personajes disponibles",
    recentServers: "Tu servidor",
    role: "Nombre del personaje:",
    rolePlaceholder: "Seleccionar personaje",
    server: "Servidor:",
    serverPlaceholder: "Seleccionar servidor",
    title: "Vincular personaje",
  },
  commentModal: {
    placeholder: "Escribe un comentario...",
    replyTo: "Responder a {username}",
    title: "Comentar",
  },
  common: {
    cancel: "Cancelar",
    confirm: "OK",
    landscapeTip: "Por favor, gire su teléfono al modo vertical para una mejor experiencia",
    loadMore: "Desliza hacia arriba para cargar más",
    loading: "Cargando...",
    loadingMore: "Cargar más...",
    noMore: "No hay más datos",
    refreshFailed: "Error al actualizar",
    refreshSuccess: "Actualizado",
    submit: "Enviar",
    all: "Todos",
    language: "Idioma",
  },
  error: {
    50002: "Token no válido o ha caducado",
    50006: "Ese apodo ya está en uso",
    50007: "Solo puede cambiar su apodo una vez al mes, ya lo ha cambiado este mes",
    50008: "Puntos insuficientes",
    50301: "No tienes permiso para publicar",
    50302: "Límite de publicaciones alcanzado",
    50303: "La longitud del contenido no cumple con los requisitos",
    50304:
      "El contenido contiene palabras sensibles. Modifícalo e inténtalo de nuevo.",
    50308: "No tienes permiso para ver esta publicación",
    50309: "La publicación ha sido eliminada o movida",
    50351: "Este hilo está cerrado, no puedes responder",
    50353: "No tienes permiso para responder",
    50354: "Las respuestas están prohibidas en esta sección",
    50355:
      "Estás publicando con demasiada frecuencia, inténtalo de nuevo más tarde",
    50356: "Se ha alcanzado el límite de publicaciones por hora",
    50361: "Comentario no encontrado",
    50500: "Aún no puedes usar la función de búsqueda",
    50501: "Función de búsqueda desactivada",
    50502: "El contenido contiene palabras sensibles. Modifícalo e inténtalo de nuevo.",
    50505: "Búsqueda demasiado frecuente, por favor intente de nuevo más tarde",
    50703: "Revisión de imagen fallida",
    50704: "El contenido de la imagen no cumple las normas",
    50214: "Error al compartir: no te has unido a ninguna @:shareModal.alliance.",
    common: "La operación falló, inténtalo de nuevo más tarde.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Sesión iniciada",
    loginInSuccess: "Inicio de sesión exitoso",
    pleaseLogin: "Primero debes iniciar sesión.",
    loginNow: "Iniciar sesión",
    pullToRefresh: "Desliza hacia abajo para actualizar",
    releaseToRefresh: "Suelta para actualizar",
    signFailed: "Error al iniciar sesión",
    signIn: "Iniciar sesión",
    signInFailedTip: "Error al iniciar sesión, inténtalo de nuevo más tarde",
    signSuccess: "Inicio de sesión completado con éxito",
    goToShop: "Ir al Centro de Puntos",
    sortByLastPost: "Comentarios recientes",
    sortByTime: "Lo más reciente",
    tags: {
      activity: "Evento",
      chats: "Debatir",
      guide: "Guía",
      recommend: "Recomendar",
      news: "Noticias",
    },
    unboundRole: "Personaje no vinculado",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "En mantenimiento",
    message: "Lo sentimos, el foro del juego está actualmente en mantenimiento. Por favor, intente de nuevo más tarde.",
  },
  mentionModal: {
    searchPlaceholder: "Buscar usuario",
    title: "Seleccionar usuario",
  },
  nicknameModify: {
    alreadyRenamed:
      "El apodo solo se puede cambiar una vez al mes y ya lo has cambiado este mes.",
    changedNickname: "Cambiar apodo",
    cost: "Costo",
    date: "Fecha",
    getMore: "Obtener",
    nicknameTooShort: "El apodo debe tener al menos 3 caracteres",
    coinNotEnough: "Puntos insuficientes",
    placeholder: "Escribe tu apodo",
    recordTitle: "Editar historial",
    sameNickname: "El nuevo apodo no puede ser igual al actual.",
    success: "Cambios guardados",
    viewRecord: "Editar historial",
  },
  notice: {
    empty: "Aún no hay mensajes",
    likeComment: "A {username} le gustó tu comentario",
    likePost: "A {username} le gustó tu publicación",
    mentionComment: "{username} mencionó tu comentario",
    mentionPost: "{username} mencionó tu publicación",
    replyComment: "{username} respondió a tu comentario",
    replyPost: "{username} respondió a tu publicación",
    system: "Notificación del sistema",
    tabs: {
      like: "Me gusta",
      mention: "Me mencionó",
      notification: "Notificación",
      reply: "Me respondió",
    },
    title: "Notificación de mensaje",
  },
  operateModal: {
    confirmDelete: "¿Realmente quieres eliminar esta publicación?",
    copyFailed: "Error al copiar",
    copyLink: "Copiar enlace",
    copySuccess: "Copiado",
    delete: "Eliminar",
    shareToGame: "Compartir en el juego",
    deleteFailed: "Error al eliminar",
    deleteSuccess: "Eliminación completada",
    title: "Acción",
  },
  shareModal: {
    selectChannelTitle: "Selecciona el canal para compartir",
    channelLabel: "Canal",
    channelPlaceholder: "Seleccionar canal",
    alliance: "Alianza",
    shareSuccess: "Compartido correctamente",
    continueBrowse: "Seguir navegando",
    goToGame: "Ver en el juego",
    noThreadTip: "Abre una publicación primero",
  },
  post: {
    create: {
      contentEmpty: "El contenido no puede estar vacío",
      contentPlaceholder: "Di algo...",
      failed: "Error al publicar",
      fileTooLarge: "El tamaño del archivo supera el límite (máx. {maxSize})",
      image: "Imagen",
      imageSizeLimit: "El tamaño de la imagen debe ser inferior a 5 MB",
      imageUploadFailed: "Error al subir la imagen",
      imageUploadSuccess: "Imagen subida",
      imageUploading: "Subiendo imagen. Espera, por favor.",
      invalidFileType: "Tipo de archivo no compatible",
      maxCharsReached:
        "Límite máximo de caracteres alcanzado ({max} caracteres)",
      mention: "{'@'}",
      selectBoard: "Seleccionar sección",
      topicLabel: "Tema",
      submit: "Publicar",
      submitting: "Publicando...",
      success: "Publicado",
      title: "Publicación",
      titleEmpty: "El título no puede estar vacío",
      titlePlaceholder: "Ingresa el título",
      video: "Video",
      videoSizeLimit: "El tamaño del video debe ser inferior a 50 MB",
      videoUploadFailed: "Error al subir el video",
      videoUploadSuccess: "Video subido",
      videoUploading: "Subiendo video. Espera, por favor...",
    },
    title: "Publicación",
  },
  postDetail: {
    allComments: "Todas las respuestas de {num}",
    allReplies: "Responder a todos",
    author: "Autor",
    cancelFavorite: "Eliminado de favoritos",
    commentTooShort: "El comentario debe tener al menos 5 caracteres",
    translate: "Traducir",
    translating: "Traduciendo...",
    translateSuccess: "Traducción exitosa",
    translateFailed: "Error en la traducción",
    translatedTo: "Traducido a",
    earliest: "Respuesta más antigua",
    favoriteSuccess: "Añadido a favoritos",
    floor: "Floor",
    latest: "Respuesta más reciente",
    loadFailed: "Error al cargar",
    noContent: "Sin contenido",
    onlyAuthor: "Solo autor",
    reply: "Responder",
    replyTo: "Responder",
    sendFailed: "Error al enviar",
    sendSuccess: "Enviado",
    sending: "Enviando...",
    viewOriginalPost: "Publicación original",
    writeSomething: "Dice algo...",
  },
  profile: {
    addLikeSuccess: "Me gusta",
    cancelLikeSuccess: "No me gusta",
    communityId: "ID de la comunidad",
    editNickname: "Cambiar apodo",
    followSuccess: "Siguiendo",
    followed: "Siguiendo",
    followers: "Seguidores",
    follow: "Seguir",
    likes: "Me gustas",
    noFavorites: "Sin favoritos",
    noPosts: "Sin actualizaciones",
    shopLabel: "Tienda de Puntos",
    tabs: {
      favorites: "Mis favoritos",
      posts: "Mis actualizaciones",
    },
    title: "Perfil",
    unfollowSuccess: "Dejar de seguir",
  },
  search: {
    btn: "Buscar",
    empty: "Sin contenido relacionado",
    filter: {
      dateline: "Lo más reciente",
      title: "Ordenar",
      views: "Popular",
    },
    historyTitle: "Historial de búsqueda",
    hotTitle: "Tendencias",
    relatedPosts: "Publicaciones relacionadas",
    tabs: {
      post: "Publicación",
      user: "Usuario",
    },
  },
  setting: {
    about: "Sobre nosotros",
    logout: "Cerrar sesión",
    logoutSuccess: "Sesión cerrada",
    privacy: "Política de privacidad",
    service: "Términos y condiciones",
    title: "Ajustes",
  },
  shop: {
    emptyTip: "Tienda en construcción, ¡vuelve pronto!",
    record: "Historial de intercambios",
    title: "Centro de intercambio",
    bindRole: "Vincular personaje",
    switchRole: "Cambiar de personaje",
    tabs: {
      tasks: "Tareas de puntos",
      rewards: "Intercambio de recompensas",
    },
    taskInProgress: "En progreso",
    taskCompleted: "Completado",
    goToComplete: "Misión",
    exchange: "Intercambiar",
    exchanged: "Intercambiado",
    exchangeConfirmTitle: "¿Confirmar intercambio?",
    currentCoins: "Puntos actuales",
    costCoins: "Puntos a consumir",
    receiveRole: "Personaje receptor",
    exchangeSuccess: "Intercambio exitoso",
    exchangeFailed: "Intercambio fallido",
  },
  exchangeRecord: {
    time: "Tiempo",
    content: "Contenido",
    points: "Puntos",
    empty: "No hay registros de intercambio",
  },
  tabBar: {
    home: "Inicio",
    notice: "Mensaje",
    profile: "Mi",
  },
  time: {
    hoursAgo: "hace {hours} horas",
    minutesAgo: "hace {minutes} minutos",
  },
};
